import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import { ClassNameMap } from "@material-ui/styles";

interface RaitingTileProps {
  value: number;
  ratingState: number;
  setRatingState: any;
}

const borderRadius = 28;

const useStyles = makeStyles(() => ({
  container: {
    display: "inline-block",
  },
  basedElement: {
    minWidth: 99,
    height: 56,
    fontSize: 21,
    fontWeight: 900,
    fontFamily: "lato",
    padding: 0,
    "&:hover": {
      backgroundColor: "white",
      color: "#001937",
    },

    "@media (max-width: 1100px)": {
      minWidth: 92,
    },
    "@media (max-width: 1024px)": {
      minWidth: 52,
      height: 46,
      fontWeight: "normal",
    },
  },
  leftElement: {
    borderTopLeftRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  middleElement: {
    borderRadius: 0,
    borderLeft: "1px solid #001234",
  },
  rightElement: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderLeft: "1px solid #001234",
  },
  lowRating: {
    backgroundColor: "#E05151",
    color: "white",
  },
  middleRating: {
    backgroundColor: "#ECA04D",
    color: "white",
  },
  highRating: {
    backgroundColor: "#3FA052",
    color: "white",
  },
  chosenRating: {
    backgroundColor: "white",
    color: "#001937",
  },
}));

const getStyle = (value: number, classes: ClassNameMap, ratingState: number): string => {
  const chosen = value === ratingState;
  const { lowRating, middleRating, highRating, basedElement, middleElement, rightElement, leftElement, chosenRating } = classes;
  switch (true) {
    case value === 0:
      return clsx(basedElement, leftElement, chosen ? chosenRating : lowRating);
    case value > 0 && value <= 6:
      return clsx(basedElement, middleElement, chosen ? chosenRating : lowRating);
    case value === 7 || value === 8:
      return clsx(basedElement, middleElement, chosen ? chosenRating : middleRating);
    case value === 9:
      return clsx(basedElement, middleElement, chosen ? chosenRating : highRating);
    case value === 10:
      return clsx(basedElement, rightElement, chosen ? chosenRating : highRating);
    default:
      return "";
  }
};

const RaitingTile: React.FC<RaitingTileProps> = ({ value, ratingState, setRatingState }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Button className={getStyle(value, classes, ratingState)} onClick={() => setRatingState(value)}>
        {value}
      </Button>
    </div>
  );
};

export default RaitingTile;
